import { create } from 'zustand';
import { persist } from '../node_modules/zustand/esm/middleware.js';
import { getCompatConfig } from '../compat.js';
import { shallow as shallow$1 } from '../node_modules/zustand/esm/shallow.js';
import { ensureError, isDefined } from '@fabric-app/utils/guards';
import { captureException } from './sentry.js';
import { delayedTrackZustand } from './openreplay.js';

const isMobilePlatform = (platform) => {
  return platform === "capacitor-ios" || platform === "capacitor-android" || platform === "fabric-mobile-ios" || platform === "fabric-mobile-android" || platform === "ios" || platform === "android";
};
const isCapacitorPlatform = (platform) => {
  return platform === "capacitor-ios" || platform === "capacitor-android";
};
const isFabricMobilePlatform = (platform) => {
  return platform === "fabric-mobile-ios" || platform === "fabric-mobile-android";
};
const isExtensionPlatform = (platform) => {
  return platform === "chrome-extension";
};
const isDesktopPlatform = (platform) => {
  return platform === "desktop";
};
const isWebPlatform = (platform) => {
  return platform === "web";
};
const isServerPlatform = (platform) => {
  return platform === "server";
};
const getSimplifiedPlatform = (platform) => {
  if (isMobilePlatform(platform)) {
    return platform === "capacitor-android" || platform === "fabric-mobile-android" ? "android" : "ios";
  }
  if (isExtensionPlatform(platform)) {
    return "extension";
  }
  return platform;
};
const usePlatformInfo = create()(delayedTrackZustand(persist((set) => ({
  platform: "web",
  simplifiedPlatform: "web",
  platformVersion: null,
  refresh: async () => {
    const platformConfig = getCompatConfig().PLATFORM;
    const platform = platformConfig.getPlatform();
    const simplifiedPlatform = platformConfig.getSimplifiedPlatform();
    const platformVersion = await platformConfig.getPlatformVersion();
    set({
      platform,
      simplifiedPlatform,
      platformVersion
    });
  }
}), {
  name: "platform-info",
  onRehydrateStorage: () => {
    setTimeout(() => {
      const platformConfig = getCompatConfig().PLATFORM;
      platformConfig.getPlatformVersion().then((platformVersion) => {
        usePlatformInfo.setState({
          platformVersion,
          platform: platformConfig.getPlatform(),
          simplifiedPlatform: platformConfig.getSimplifiedPlatform()
        });
      }).catch((error) => {
        captureException(ensureError(error));
      });
    }, 1);
  }
})));
const usePlatform = () => {
  return usePlatformInfo((state) => state.platform, shallow$1);
};
const useSimplifiedPlatform = () => {
  return usePlatformInfo((state) => state.simplifiedPlatform, shallow$1);
};
const usePlatformVersion = () => {
  return usePlatformInfo((state) => state.platformVersion, shallow$1);
};
const getCompatPlatform = () => {
  return getCompatConfig().PLATFORM;
};
const openExternal = (url, target) => {
  return getCompatPlatform().openExternal(url, target);
};
const isInDesktopPlatform = () => {
  return isDesktopPlatform(getCompatPlatform().getPlatform());
};
const isInCapacitorPlatform = (platform) => {
  return isDefined(platform) ? getCompatPlatform().getPlatform() === platform : isCapacitorPlatform(getCompatPlatform().getPlatform());
};
const isInFabricMobilePlatform = (platform) => {
  return isDefined(platform) ? getCompatPlatform().getPlatform() === platform : isFabricMobilePlatform(getCompatPlatform().getPlatform());
};
const isInExtensionPlatform = (platform) => {
  return isDefined(platform) ? getCompatPlatform().getPlatform() === platform : isExtensionPlatform(getCompatPlatform().getPlatform());
};
const isInWebPlatform = () => {
  return isWebPlatform(getCompatPlatform().getPlatform());
};
const isInServerPlatform = () => {
  return isServerPlatform(getCompatPlatform().getPlatform());
};
const isInMobilePlatform = (platform) => {
  return isDefined(platform) ? getCompatPlatform().getPlatform() === platform : isMobilePlatform(getCompatPlatform().getPlatform());
};
const isInNativeApp = () => {
  return isInMobilePlatform() || isInDesktopPlatform();
};
const isInMobileSimplifiedPlatform = (platform) => {
  return isDefined(platform) ? getCompatPlatform().getSimplifiedPlatform() === platform : getCompatPlatform().getSimplifiedPlatform() === "ios" || getCompatPlatform().getSimplifiedPlatform() === "android";
};

export { getCompatPlatform, getSimplifiedPlatform, isCapacitorPlatform, isDesktopPlatform, isExtensionPlatform, isFabricMobilePlatform, isInCapacitorPlatform, isInDesktopPlatform, isInExtensionPlatform, isInFabricMobilePlatform, isInMobilePlatform, isInMobileSimplifiedPlatform, isInNativeApp, isInServerPlatform, isInWebPlatform, isMobilePlatform, isServerPlatform, isWebPlatform, openExternal, usePlatform, usePlatformInfo, usePlatformVersion, useSimplifiedPlatform };
//# sourceMappingURL=platform.js.map
